import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, setAuthToken } from "../lib/api";

const STORAGE_KEY = "sukaanyas_admin_token";
const AdminAuthContext = createContext({
    admin: null,
    token: null,
    loading: true,
    login: async () => {},
    logout: () => {},
});

export function AdminAuthProvider({ children }) {
    const [admin, setAdmin] = useState(null);
    const [token, setToken] = useState(() => localStorage.getItem(STORAGE_KEY));
    const [loading, setLoading] = useState(true);

    const restore = useCallback(async () => {
        const stored = localStorage.getItem(STORAGE_KEY);
        if (!stored) {
            setLoading(false);
            return;
        }
        setAuthToken(stored);
        try {
            const { data } = await api.get("/admin/me");
            setAdmin(data);
            setToken(stored);
        } catch (_e) {
            localStorage.removeItem(STORAGE_KEY);
            setAuthToken(null);
            setAdmin(null);
            setToken(null);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        restore();
    }, [restore]);

    const login = useCallback(async (email, password) => {
        const { data } = await api.post("/admin/login", { email, password });
        localStorage.setItem(STORAGE_KEY, data.access_token);
        setAuthToken(data.access_token);
        setToken(data.access_token);
        setAdmin(data.admin);
        return data.admin;
    }, []);

    const logout = useCallback(() => {
        localStorage.removeItem(STORAGE_KEY);
        setAuthToken(null);
        setToken(null);
        setAdmin(null);
    }, []);

    return (
        <AdminAuthContext.Provider value={{ admin, token, loading, login, logout }}>
            {children}
        </AdminAuthContext.Provider>
    );
}

export function useAdminAuth() {
    return useContext(AdminAuthContext);
}
